import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

type MaintenanceRow = {
  provider_id: number;
  provider_name: string;
  provider_code: string;
  category_name?: string | null;
  category_code?: string | null;
  maintain_from: string;
  maintain_to: string | null;
  remarks?: string | null;
  display_time: string;
  is_ongoing: boolean;
};

type ModalData = {
  marquee: any[]; // array from localStorage 'marquees'
  maintenance: {
    rows: MaintenanceRow[];
    empty_message?: string;
  };
};

@Component({
  selector: 'app-read-more-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDialogModule],
  templateUrl: './read-more-modal.component.html',
  styleUrl: './read-more-modal.component.scss',
})
export class ReadMoreMarqueeModalComponent implements OnInit {

  // Tab: default to "general"
  activeTab: 'general' | 'maintenance' = 'general';

  // Data
  marqueeRows: any[] = [];
  maintenanceRows: MaintenanceRow[] = [];
  emptyMessage = '';

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    dots: true,
    items: 1
  };

  constructor(
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
    public dialogRef: MatDialogRef<ReadMoreMarqueeModalComponent>,
  ) {}

  ngOnInit() {
    // Get data from LocalStorage (passed in via dialog data)
    this.marqueeRows = Array.isArray(this.data?.marquee) ? this.data.marquee : [];
    this.maintenanceRows = Array.isArray(this.data?.maintenance?.rows) ? this.data.maintenance.rows : [];
    this.emptyMessage = this.data?.maintenance?.empty_message || this.translateService.instant('Please try one of our other game providers for now. Sorry for the inconvenience.');

    // Set default tab to maintenance if no general announcements
    if (!this.marqueeRows?.length) {
      this.activeTab = 'maintenance';
    }
  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  trackByIdx(index: number, item: any): number {
    return index;
  }

}
